let appFunction = {};

appFunction.login = function() {
    if (typeof(window.IARTSCHOOL) != "undefined") {
        window.IARTSCHOOL.login();
    } else if (typeof(window.android) != "undefined") {
        window.android.loginOut();
    }
}
appFunction.share = function(obj) {
    if (typeof(window.IARTSCHOOL) != "undefined") {
        window.IARTSCHOOL.share(obj);
    } else if (typeof(window.android) != "undefined") {
        window.android.share(JSON.stringify(obj));
    }
}
appFunction.delayShare = function(obj) {
    if (typeof(window.IARTSCHOOL) != "undefined") {
        window.IARTSCHOOL.delayShare(obj);
    } else if (typeof(window.android) != "undefined") {
        window.android.delayShare(JSON.stringify(obj));
    }
}
appFunction.courseDetail = function(obj) {
    if (typeof window.android != "undefined") {
        window.android.toCourseDetails(JSON.stringify(obj)); //{ courseid: item.referencevalue }
    } else if (typeof window.IARTSCHOOL != "undefined") {
        window.IARTSCHOOL.toCourseDetails(obj); //{ courseid: item.referencevalue }
    }
}
appFunction.buyPackage = function(obj) {
    if (typeof window.android != "undefined") {
        window.android.toBuyCoursePackage(
            JSON.stringify(obj) //{ productid: this.info.productid }
        );
    } else if (typeof window.IARTSCHOOL != "undefined") {
        window.IARTSCHOOL.toBuyCoursePackage(obj); //{productid: this.info.productid,}
    }
}
appFunction.back = function() {
    if (typeof window.IARTSCHOOL != "undefined") {
        window.IARTSCHOOL.backToHome();
    } else if (typeof window.android != "undefined") {
        window.android.exitPage();
    }
}
appFunction.buyVip = function(obj) {
    if (typeof window.android != "undefined") {
        window.android.toBuyVip(JSON.stringify(obj)); //{ referencevalue: item.businessid }
    } else if (typeof window.IARTSCHOOL != "undefined") {
        window.IARTSCHOOL.toBuyVip(obj); //{ referencevalue: item.businessid}
    }
}
appFunction.saveImg = function(url) {
    if (typeof window.android != "undefined") {
        window.android.savePicture(JSON.stringify({ imgSource: url }));
    } else if (typeof window.IARTSCHOOL != "undefined") {
        window.IARTSCHOOL.saveImg({ base64: "https://picture.iartschool.com/code.png" + url, });
    }
}
export default appFunction;